import { render, staticRenderFns } from "./DxWorker.vue?vue&type=template&id=e495ee7e&scoped=true&"
import script from "./DxWorker.vue?vue&type=script&lang=js&"
export * from "./DxWorker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e495ee7e",
  null
  
)

export default component.exports